/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RoutesRecognized } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { interval, Subscription } from 'rxjs';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { CookieConsentComponent } from './shared/components/cookie-consent/cookie-consent.component';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared/services/auth.service';
import { I18nService } from './shared/i18n/i18n.service';
import { PageTitleService } from './shared/services/page-title.service';
// import { mainModule } from 'process';

// eslint-disable-next-line no-shadow
export enum Layouts {
  simple,
  main,
}

@Component({
    selector: 'app-root',
    imports: [SimpleLayoutComponent, MainLayoutComponent, CookieConsentComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit, OnDestroy {
  layouts = Layouts;
  layout: Layouts = Layouts.main;
  private sessionCheckSubscription?: Subscription;

  constructor(
    // wstrzykniete od razu, zeby jezyk danych (environment.language) byl
    // ustawiony zanim ktokolwiek zdazy z niego skorzystac
    private i18n: I18nService, private pageTitle: PageTitleService,
    private router: Router, private cookieService: CookieService, private authService: AuthService) { }

  getLayout(child: ActivatedRouteSnapshot | null): Layouts {
    if (child instanceof ActivatedRouteSnapshot) {
      const layout = child.data?.['layout'];
      if (child.firstChild) {
        const childLayout = this.getLayout(child.firstChild);
        if (childLayout != null) {
          return childLayout;
        }
      }
      return layout;
    }
    return Layouts.main;
  }

  // We can't use `ActivatedRoute` here since we are not within a `router-outlet` context yet.
  ngOnInit() {
    // tytul karty w przegladarce zmienia sie razem z trasa i jezykiem
    this.pageTitle.start();

    // Synchronize frontend state with backend session
    const username = localStorage.getItem('username');
    const sessionCookie = this.cookieService.get('session_timeout');

    // O zalogowaniu decyduje backend - localStorage i ciasteczko to tylko ślad
    // po poprzedniej sesji, więc przy starcie potwierdzamy je u źródła.
    // Bez tego karta otwarta po wygaśnięciu sesji pokazywała przyciski
    // zalogowanego, a dane przychodziły już anonimowe (np. drzewo bez osób
    // żyjących). Odpytujemy tylko wtedy, gdy cokolwiek sugeruje zalogowanie -
    // dla zwykłego gościa nie ma czego sprawdzać.
    if (username || sessionCookie) {
      this.authService.whoisSignedIn().subscribe({
        next: (data) => {
          if (data.username) {
            localStorage.setItem('username', data.username);
            localStorage.setItem('userid', data.id);
            localStorage.setItem('expires', data.expires);
            environment.aiNameSex = data.ai_name_sex === true;
            if (!username) {
              // Notify about auth state change
              this.authService.authStateChanged.next(true);
            }
          } else {
            this.forgetStaleSession(username);
          }
        },
        error: () => {
          // 403 czyści już interceptor; tu domykamy pozostałe przypadki
          this.forgetStaleSession(username);
        }
      });
    }

    // Check session cookie every second - if missing, clear localStorage username
    this.sessionCheckSubscription = interval(1000).subscribe(() => {
      const sessionCookie = this.cookieService.get('session_timeout');
      const username = localStorage.getItem('username');

      if (!sessionCookie && username) {
        this.authService.cleanupCredentials();
        // Notify about auth state change
        this.authService.authStateChanged.next(false);
      }
    });

    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.layout = this.getLayout(data.state.root.firstChild);

        if (this.layout === undefined) {
          this.layout = Layouts.main;
        }
      }
    });
  }

  /** Backend nie zna już tej sesji - kasujemy ślad po zalogowaniu w przeglądarce. */
  private forgetStaleSession(hadUsername: string | null) {
    if (hadUsername) {
      this.authService.cleanupCredentials();
      this.authService.authStateChanged.next(false);
    }
  }

  ngOnDestroy() {
    // Clean up subscription to prevent memory leaks
    this.sessionCheckSubscription?.unsubscribe();
  }

}

